import {
	Id,
	LaravelResponse,
	ModelUsageResource,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import { EventTypeIndexResource, EventTypeSaveRequest, EventTypeUpdateResource } from "../types/eventType";

const baseKey = ["event-types"];
const showUsageKey = (id: Id) => [...baseKey, `${id}`, "usage"];

export const eventTypeService = {
	baseKey,
	...withIndexEndpoint<EventTypeIndexResource>(baseKey),
	...withShowEndpoint<EventTypeUpdateResource>(baseKey),
	...withStoreEndpoint<EventTypeSaveRequest>(baseKey),
	...withUpdateEndpoint<EventTypeSaveRequest>(baseKey),
	...withDestroyEndpoint(baseKey),
	showUsageKey,
	showUsage: (contactTypeId: Id) =>
		axios.get<LaravelResponse<ModelUsageResource[]>>(keyToUrl(showUsageKey(contactTypeId))),
};
